import shieldIcon from "../../assets/contact-us-page/Background+Border-3.png";
import lockIcon from "../../assets/contact-us-page/Background+Border-4.png";
import documentIcon from "../../assets/contact-us-page/Background+Border-5.png";
import personShieldIcon from "../../assets/contact-us-page/Background+Border-1.png";
import { useInView } from "../../hooks/useInView";

const FEATURES = [
  {
    icon: shieldIcon,
    title: "Secure & Protected",
    description:
      "Your information is safeguarded throughout the application process with enterprise encryptions.",
  },
  {
    icon: lockIcon,
    title: "Privacy First",
    description:
      "Your personal information is handled responsibly and never sold to third parties.",
  },
  {
    icon: documentIcon,
    title: "Transparent & Clear",
    description:
      "Loan terms, applicable charges, and repayment details are clearly communicated upfront.",
  },
  {
    icon: personShieldIcon,
    title: "Information Security",
    description:
      "We use verified safe practices to protect your sensitive financial credentials.",
  },
];

export function SecurityNote() {
  const { ref, inView } = useInView<HTMLDivElement>();

  return (
    <section className="w-full bg-white px-4 py-16 sm:py-20">
      <div className="mx-auto w-full max-w-[1290px]">
        <div
          ref={ref}
          className={`max-w-[672px] ${inView ? "in-view" : ""}`}
        >
          <span className="reveal-scroll delay-1 rounded-full bg-[#e0f6f5] px-4 py-[6px] text-xs font-semibold uppercase tracking-[0.6px] text-brand-teal">
            Your Data. Your Privacy. Your Trust.
          </span>
          <h2 className="reveal-scroll delay-2 pt-4 text-2xl font-bold leading-tight text-[#1c1917] sm:text-3xl">
            Security Note — It's easier than ever before.
          </h2>
          <p className="reveal-scroll delay-3 pt-3 text-sm leading-6 text-[#475569]">
            We take the security of your personal and financial information
            seriously. Your information is handled securely and used in
            accordance with our privacy practices.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {FEATURES.map((feature) => (
            <div
              key={feature.title}
              className="flex flex-col rounded-2xl border border-solid border-[#e2e8f0] p-6"
            >
              <img src={feature.icon} alt="" className="h-12 w-12" />
              <h3 className="pt-[10px] text-lg font-bold leading-tight text-[#1c1917]">
                {feature.title}
              </h3>
              <p className="pt-[6px] text-sm leading-5 text-[#64748b]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 rounded-xl bg-[#ecfdf9] px-8 py-4 text-center">
          <p className="text-sm text-[#176766]">
            We use strict adherence to RBI fair practice guidelines to
            protect your personal and financial information.
          </p>
        </div>
      </div>
    </section>
  );
}
